import types, { AdCampaignState } from './types';
import actionCreators from './actions';
import { ValueOf } from 'sl-api-connector';
import { AD_STATUS_DERIVED } from 'sl-ad-campaign-manager-data-model';

// ------------------------------------
// Reducer
// ------------------------------------

const adCampaignStatesAvailable: AdCampaignState[] = [
  {
    id: AD_STATUS_DERIVED.DELIVERING,
    statusDerived: AD_STATUS_DERIVED.DELIVERING,
    name: 'Delivering',
    displayName: 'Delivering',
    type: 'adCampaignState'
  },
  {
    id: AD_STATUS_DERIVED.PAUSED,
    statusDerived: AD_STATUS_DERIVED.PAUSED,
    name: 'Paused',
    displayName: 'Paused',
    type: 'adCampaignState'
  },
  {
    id: AD_STATUS_DERIVED.ENDED,
    statusDerived: AD_STATUS_DERIVED.ENDED,
    name: 'Ended',
    displayName: 'Ended',
    type: 'adCampaignState'
  },
  {
    id: AD_STATUS_DERIVED.OUT_OF_BUDGET,
    statusDerived: AD_STATUS_DERIVED.OUT_OF_BUDGET,
    name: 'Out of budget',
    displayName: 'Out of budget',
    type: 'adCampaignState'
  }
];
type Action = ValueOf<{ [K in keyof typeof actionCreators]: ReturnType<(typeof actionCreators)[K]> }>;

export function adCampaignStates(state = adCampaignStatesAvailable, action: Action) {
  switch (action.type) {
    case types.RECEIVE_AD_CAMPAIGN_STATES:
      return action.adCampaignStates;
    case types.CLEAR_AD_CAMPAIGN_STATES:
      return [];
    default:
      return state;
  }
}
